import type { SendRequestType } from '@/lib/utils/shared/httpTools'
import httpTools from '@/lib/utils/shared/httpTools'

type Props = {
  cardNumber: string
}

type HydraGetWorldPayDDCResponse = {
  ddcHTML: string
  sessionId: string
}

export const HydraGetWorldPayDDC = async ({ cardNumber }: Props) => {
  const request: SendRequestType = {
    method: 'POST',
    url: '/ddc',
    data: {
      bin: cardNumber,
    },
    withAuth: false,
  }

  return httpTools.sendRequest<HydraGetWorldPayDDCResponse>(request)
}
